export function formatPolishCurrency(number) {
  // If the input is NaN or not a finite number, default to 0
  if (isNaN(number) || !isFinite(number)) {
    number = 0;
  }

  // Get current language from i18n
  const currentLanguage = localStorage.getItem('i18nextLng') || 'pl';

  // Convert the number to a string with 2 decimal places
  const formattedNumber = Number(number).toFixed(2);

  // Split the number into integer and decimal parts
  const [integerPart, decimalPart] = formattedNumber.split('.');

  if (currentLanguage === 'pl') {
    // Polish format: space separator, comma decimal, zł suffix
    const integerWithSpaces = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const formattedCurrency = `${integerWithSpaces},${decimalPart}`;
    return `${formattedCurrency} zł`;
  } else if (currentLanguage === 'uk') {
    // Ukrainian format: space separator, comma decimal, ₴ suffix
    const integerWithSpaces = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const formattedCurrency = `${integerWithSpaces},${decimalPart}`;
    return `${formattedCurrency} ₴`;
  } else {
    // English format: comma separator, dot decimal, $ prefix
    const integerWithCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const formattedCurrency = `${integerWithCommas}.${decimalPart}`;
    return `$${formattedCurrency}`;
  }
}

export function formatTCCurrency(number) {
  // If the input is NaN or not a finite number, default to 0
  if (isNaN(number) || !isFinite(number)) {
    number = 0;
  }

  // Convert the number to a string with 2 decimal places
  const formattedNumber = Number(number).toFixed(2);

  // Split the number into integer and decimal parts
  const [integerPart, decimalPart] = formattedNumber.split('.');

  // Add a space as a thousands separator
  const integerWithSpaces = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  // Combine the formatted integer and decimal parts with a comma
  const formattedCurrency = `${integerWithSpaces},${decimalPart}`;

  return `${formattedCurrency} TC`;
}